module.exports = __webpack_public_path__ + "static/media/keche11.e707927b.png";